import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center p-3 mt-4 w-full font-medium rounded-md border border-solid" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "leading-none text-black" }
const _hoisted_4 = { class: "flex flex-col items-start mt-4 w-full leading-none text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResourceCard = _resolveComponent("ResourceCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ResourceCard, {
          icon: _ctx.wordIcon,
          text: "Word Doc",
          width: "197px",
          resourceType: "word-doc",
          onCardClick: _ctx.handleCardClick,
          onDownloadClick: _ctx.handleDownloadClick
        }, null, 8, ["icon", "onCardClick", "onDownloadClick"]),
        _createVNode(_component_ResourceCard, {
          icon: _ctx.powerpointSlidesIcon,
          text: "Powerpoint Slides",
          width: "197px",
          resourceType: "powerpoint-slides",
          class: "mt-3",
          onCardClick: _ctx.handleCardClick,
          onDownloadClick: _ctx.handleDownloadClick
        }, null, 8, ["icon", "onCardClick", "onDownloadClick"])
      ])
    ])
  ]))
}